module.exports = __webpack_public_path__ + "static/passnip-logo-white-1ba096f7da607e7771084559ad17470b.svg";